import api from '../../../../../../resources/js/services/api';

export default {

    getUserInfo() {
        return api().get('/user/get-current-user');
    },

    sendSupportRequest(form) {
        return api().post('/applicant/support/send', form)
    },

    updatePersonalForm (id, form) {
        return api().put('/user/profile/personalDetails/' + id + '/update', form)
    },

    updateAddressForm (id, form) {
        return api().put('/user/profile/address/' + id  + '/update', form)
    },

    updatePositionsForm (id, form) {
        return api().put('/user/profile/positionAndLicenses/' + id + '/update', form)
    },

    updateOrnaExpForm (id, form) {
        return api().put('/user/profile/workExperience/' + id+ '/update', form)
    },

    updateWorkHistoryForm (id, form) {
        return api().put('/user/profile/workHistory/' + id + '/update', form)
    },

    updateQualificationsForm (id, form) {
        return api().put('/user/profile/qualificationAndLanguages/' + id + '/update', form)
    },

    updateEducationsForm (id, form) {
        return api().put('/user/profile/educationDetails/' + id + '/update', form)
    },

    updateReferencesForm (id, form) {
        return api().put('/user/profile/references/' + id + '/update', form)
    },

    updateQuestionsForm (id, form) {
        return api().put('/user/profile/additionalQuestions/' + id + '/update', form)
    },

    updateAvailabilityForm (id, form) {
        return api().put('/user/profile/availability/' + id + '/update', form)
    },

}
